import axios from 'axios'
import { RootState } from '@/store'
import { ActionTree, Module, MutationTree } from 'vuex'
import { Language } from '../global/models'

const endpoint = '/languages'

export type LanguageState = {
  languages: Language[];
}

class LanguageStore implements Module<LanguageState, RootState> {
  namespaced = true

  state() {
    return { languages: [] }
  }

  mutations: MutationTree<LanguageState> = {
    SET_LANGUAGES(state, languages) {
      state.languages = languages
    }
  }

  actions: ActionTree<LanguageState, RootState> = {
    async getLanguages({ commit }) {
      const result = await axios.get<{ data: Language[] }>(endpoint)
      commit('SET_LANGUAGES', result.data)
    }
  }
}

export default new LanguageStore()
